import type { PresetColorType } from 'antd/es/_util/colors';

import type { BookingStatus } from 'app/typings/core/admin/bookings/enum/bookingStatus';

type FormatVCCStatus = {
  [key in BookingStatus]: {
    label: string;
    color?: PresetColorType;
  };
};

export const formatReservationStatus = (
  reservationStatus: BookingStatus
): FormatVCCStatus[BookingStatus] => {
  // eslint-disable-next-line @typescript-eslint/no-shadow -- inner-scope reuse, not a bug
  const formatReservationStatus: FormatVCCStatus = {
    ABORTED: {
      label: 'Aborted',
      color: undefined,
    },
    CANCELED: {
      label: 'Canceled',
      color: 'red',
    },
    PENDING: {
      label: 'Pending',
      color: 'blue',
    },
    ACCEPTED: {
      label: 'Confirmed',
      color: 'green',
    },
  };

  return formatReservationStatus[reservationStatus];
};
